import { makeAutoObservable } from 'mobx'

const normalizeId = id => String(id || '').trim()

class StudentProfileBuilderStore {
	profiles = new Map()
	isLoading = false
	loadStatus = 'idle'

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true })
	}

	setProfiles(profilesList) {
		this.profiles.clear()
		if (profilesList && Array.isArray(profilesList)) {
			profilesList.forEach(profile => {
				const studentId = normalizeId(profile?.student_id)
				if (studentId) {
					this.profiles.set(studentId, {
						profileData: profile?.profile_data || null,
						updatedAt: profile?.updated_at || null,
					})
				}
			})
		}
	}

	setLoading(loading) {
		this.isLoading = loading
		this.loadStatus = loading ? 'loading' : 'idle'
	}

	upsertProfile(studentId, profileData, updatedAt = null) {
		const key = normalizeId(studentId)
		if (!key) return
		this.profiles.set(key, {
			profileData: profileData || null,
			updatedAt: updatedAt || new Date().toISOString(),
		})
	}

	setLoadStatus(status) {
		this.loadStatus = status
		this.isLoading = status === 'loading'
	}

	getProfile(studentId) {
		const key = normalizeId(studentId)
		return this.profiles.get(key) || null
	}

	hasProfile(studentId) {
		const key = normalizeId(studentId)
		return this.profiles.has(key)
	}
}

export const studentProfileBuilderStore = new StudentProfileBuilderStore()
